import { render } from "./CreateReminder.vue?vue&type=template&id=8704325e"
import script from "./CreateReminder.vue?vue&type=script&lang=js"
export * from "./CreateReminder.vue?vue&type=script&lang=js"

import "./CreateReminder.vue?vue&type=style&index=0&id=8704325e&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__